import CoursesApiService from "./api/CoursesApiService";
import { formatPayloadToQueryString } from "@/utils/formatters";

export const getPeriods = async (payload, userToken) => {
    const queryString = formatPayloadToQueryString({
        search: payload.search,
        name: payload.name,
        companyId: payload.companyId,
        organizationId: payload.organizationId,
        status: payload.status,
        startDate: payload.start_date,
        endDate: payload.end_date,
        page: payload.page,
        perPage: payload.perPage
    });

    try {
        const response = await CoursesApiService.get(`/periods${queryString}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao buscar períodos', error);

        throw error;
    }
}

export const getPeriodById = async (periodId, userToken) => {
    try {
        const response = await CoursesApiService.get(`/periods/${periodId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao buscar período', error);

        throw error;
    }
}

export const createPeriod = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.post('/periods', payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao criar período', error);

        throw error;
    }
}

export const updatePeriod = async (payload, userToken) => {
    const { id: payloadId, periodId, ...period } = payload;
    const id = payloadId || periodId;

    try {
        const response = await CoursesApiService.put(`/periods/${id}`, period, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar período', error);

        throw error;
    }
}

export const deletePeriod = async (periodId, userToken) => {
    try {
        await CoursesApiService.delete(`/periods/${periodId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
    } catch (error) {
        console.error('Erro ao deletar período', error);

        throw error;
    }
}

export default {
    getPeriods,
    getPeriodById,
    createPeriod,
    updatePeriod,
    deletePeriod
}